<template>
  <div class="filter-cost">
    <span>от</span>
    <div class="input-wrap">
      <input v-model="cadCost_Gt" @input="onInputGt()" class="form-control" type="number" step="0.01">
      <span>₽</span>
    </div>
    <span>до</span>
    <div class="input-wrap">
      <input v-model="cadCost_Lte" @input="onInputLte()" class="form-control" type="number" step="0.01">
      <span>₽</span>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'

export default {
  name: 'FilterCostVue',
  data () {
    return {
      sss: 0,
      cadCost_Gt: '',
      cadCost_Lte: '',
      KKKinputTimerGt: null,
      inputTimerLte: null
    }
  },
  created () {
    eventBus.$on('resetRange', data => {
      this.cadCost_Gt = data
      this.cadCost_Lte = data
      eventBus.$emit('setLandListFilter', {key: 'cadCost_Gt', value: this.cadCost_Gt})
      eventBus.$emit('setLandListFilter', {key: 'cadCost_Lte', value: this.cadCost_Lte})
    })
  },
  methods: {
    onInputGt () {
      if (this.KKKinputTimerGt !== null) {
        clearTimeout(this.KKKinputTimerGt)
      }
      this.KKKinputTimerGt = setTimeout(() => {
        eventBus.$emit('setLandListFilter', {key: 'cadCost_Gt', value: this.cadCost_Gt})
      }, 1000)
    },
    onInputLte () {
      if (this.inputTimerLte !== null) {
        clearTimeout(this.inputTimerLte)
      }
      this.inputTimerLte = setTimeout(() => {
        eventBus.$emit('setLandListFilter', {key: 'cadCost_Lte', value: this.cadCost_Lte})
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.filter-cost {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .input-wrap {
    position: relative;
    input {
      font-family: 'Montserrat_B';
      width: 120px;
      height: 25px;
    }
    span {
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
      color: #545454;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/FilterType/FilterCostVue.vue